<div class="new-patient-container">
  
  <app-navbar></app-navbar>

 
  <div class="main-content">
    <div class="content-wrapper">
      <app-loader *ngIf="isCheckingExistingAccount" [fullscreen]="true" [message]="'Checking for existing account'"></app-loader>
      <app-loader *ngIf="isLoadingSlots" [fullscreen]="true" [message]="'Loading available slots...'"></app-loader>
      
      <div class="schedule-appointment" [class.with-alert]="!!inlineBannerMessage">
        <h1 class="title">Schedule a Telehealth Appointment</h1>
        <p class="subtitle">
          For in-person visits, please call us at
          <app-phone-number (clicked)="onPhoneNumberClicked()"></app-phone-number> or
          <app-clickable-link linkText="Click here." linkType="custom" customEventName="ols_in_person_click_here" (clicked)="onClickHereClicked()"></app-clickable-link><br>
          For telehealth appointments, fill out the form below to continue scheduling.
        </p>
      </div>

      <!-- Provider availability alert banner - shown above form card -->
      <div *ngIf="inlineBannerMessage" class="provider-availability-alert">
        <div class="alert-content">
          <img src="/alert.png" alt="Alert" class="alert-icon" />
          <div class="alert-text" [innerHTML]="inlineBannerMessage"></div>
        </div>
      </div>
 
      <div class="form-card">
        <!-- Inline dynamic error banner (e.g., overlap) -->
        <div *ngIf="showExistingAccountBanner" class="existing-account-banner-wrapper">
          <div class="existing-account-banner">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="existing-account-banner-icon">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
            </svg>
            <span *ngIf="existingAccountBannerUsePlainText" [innerHTML]="getExistingAccountBannerHtml()"></span>
            <span *ngIf="!existingAccountBannerUsePlainText">
              An account with these details already exists. Please log in to the
              <app-clickable-link [customClass]="'white-underline'"  linkText="Patient Portal" linkType="portal"></app-clickable-link>
              to manage your appointments or update your information.
            </span>
            <button type="button" class="existing-account-banner-close" (click)="showExistingAccountBanner=false">✕</button>
          </div>
        </div>
     
        <div class="step-indicator">
          <div class="step completed">
            <div class="step-number">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M20 6L9 17l-5-5" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="step-line"></div>
          <div class="step active">
            <div class="step-number">2</div>
          </div>
        </div>

  
        <div class="form-section">
          <h3 class="section-title">Patient's Information</h3>
          
          <form (ngSubmit)="onSubmit()" #patientForm="ngForm">
  
            <div class="form-row">
              <div class="form-col">
                <div class="field-wrapper" (focusout)="trackFieldEntered('new_patient_legal_first_name_entered', 'input', 'Legal First Name', formData.firstName)">
                  <app-inputfiled
                    label="Legal First Name"
                    [required]="true"
                    [maxLength]="20"
                    inputRestriction="alphabets"
                    [hasError]="!!formErrors.firstName"
                    [(ngModel)]="formData.firstName"
                    (ngModelChange)="onFirstNameChange()"
                    name="firstName">
                  </app-inputfiled>
                  <div class="form-error" *ngIf="formErrors.firstName">
                    {{ formErrors.firstName }}
                  </div>
                </div>
              </div>
              <div class="form-col">
                <div class="field-wrapper" (focusout)="trackFieldEntered('new_patient_legal_last_name_entered', 'input', 'Legal Last Name', formData.lastName)">
                  <app-inputfiled
                    label="Legal Last Name"
                    [required]="true"
                    [maxLength]="20"
                    inputRestriction="alphabets"
                    [hasError]="!!formErrors.lastName"
                    [(ngModel)]="formData.lastName"
                    (ngModelChange)="onLastNameChange()"
                    name="lastName">
                  </app-inputfiled>
                  <div class="form-error" *ngIf="formErrors.lastName">
                    {{ formErrors.lastName }}
                  </div>
                </div>
              </div>
            </div>

      
            <div class="form-row">
              <div class="form-col">
                <div class="field-wrapper" (focusout)="trackFieldEntered('new_patient_dob_entered', 'input', 'Birth Date', formData.birthDate)">
                  <app-calendar
                    label="Birth Date"
                    [required]="true"
                    placeholder="MM-DD-YYYY"
                    [hasError]="!!formErrors.birthDate"
                    [(ngModel)]="formData.birthDate"
                    (ngModelChange)="onBirthDateChange($event)"
                    name="birthDate">
                  </app-calendar>
                  <div class="form-error" *ngIf="formErrors.birthDate">
                    {{ formErrors.birthDate }}
                  </div>
                </div>
              </div>
              <div class="form-col">
        
                <div class="custom-dropdown-container">
                  <label class="dropdown-label">
                    Birth Sex<span class="required-asterisk">*</span>
                  </label>
                  <div class="custom-dropdown-wrapper" [class.open]="birthSexDropdownOpen">
                    <div 
                      id="birthSexTrigger"
                      class="custom-dropdown-trigger"
                      [class.has-value]="formData.birthSex"
                      [class.error]="formErrors.birthSex"
                      (click)="toggleBirthSexDropdown()"
                      tabindex="0"
                      role="button"
                      aria-haspopup="listbox"
                      [attr.aria-expanded]="birthSexDropdownOpen ? 'true' : 'false'"
                      (keydown.enter)="$event.preventDefault(); toggleBirthSexDropdown()"
                      (keydown.space)="$event.preventDefault(); toggleBirthSexDropdown()"
                      (keydown.escape)="$event.preventDefault(); birthSexDropdownOpen=false">
                      <span class="dropdown-text">{{ getBirthSexLabel() }}</span>
                      <svg class="dropdown-arrow" 
                           [class.rotated]="birthSexDropdownOpen" 
                           width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    
                    <div class="custom-dropdown-menu" *ngIf="birthSexDropdownOpen">
                      <div class="custom-dropdown-option" 
                           *ngFor="let option of birthSexOptions"
                           [class.selected]="option.value === formData.birthSex"
                           (click)="selectBirthSex(option)">
                        {{ option.label }}
                      </div>
                    </div>
                  </div>
                  <div class="form-error" *ngIf="formErrors.birthSex">
                    {{ formErrors.birthSex }}
                  </div>
                </div>
              </div>
            </div>

      
            <div class="form-row">
              <div class="form-col">
                <div class="field-wrapper" (focusout)="trackFieldEntered('new_patient_email_entered', 'input', 'Email Address', formData.email)">
                  <app-inputfiled
                    label="Email Address"
                    type="email"
                    [required]="true"
                    [maxLength]="40"
                    inputRestriction="email"
                    [hasError]="!!formErrors.email"
                    [(ngModel)]="formData.email"
                    (ngModelChange)="onEmailChange()"
                    name="email">
                  </app-inputfiled>
                  <div class="form-error" *ngIf="formErrors.email">
                    {{ formErrors.email }}
                  </div>
                </div>
              </div>
              <div class="form-col">

                <div class="custom-input-container">
                  <label class="input-label">
                    Phone Number<span class="required-asterisk">*</span>
                  </label>
                  <app-phone-input
                    [(ngModel)]="formData.phoneNumber"
                    [hasError]="!!formErrors.phoneNumber"
                    name="phoneNumber"
                    inputId="phoneNumber"
                    (ngModelChange)="onPhoneValueChange()"
                    (blurred)="onPhoneNumberFieldBlurred()"
                  ></app-phone-input>
                  <div class="form-error" *ngIf="formErrors.phoneNumber">
                    {{ formErrors.phoneNumber }}
                  </div>
                </div>
              </div>
            </div>

     
            <div class="form-row">
              <div class="form-col-full">
           
                <div class="custom-dropdown-container">
                  <label class="dropdown-label">
                    What state are you located in?<span class="required-asterisk">*</span>
                  </label>
                  <div class="custom-dropdown-wrapper" [class.open]="stateDropdownOpen">
                    <div 
                      id="stateTrigger"
                      class="custom-dropdown-trigger state-search-trigger"
                      [class.has-value]="formData.state || stateSearch"
                      [class.error]="formErrors.state"
                      (click)="openStateDropdown()"
                      role="combobox"
                      aria-haspopup="listbox"
                      [attr.aria-expanded]="stateDropdownOpen ? 'true' : 'false'">
                      <input
                        id="stateSearchInput"
                        type="text"
                        class="dropdown-search-field"
                        placeholder="Start typing state name..."
                        [ngModel]="stateDropdownOpen ? stateSearch : getStateLabel()"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onStateSearchChange($event)"
                        (focus)="openStateDropdown()"
                        (click)="$event.stopPropagation()"
                        (keydown.enter)="selectFirstStateMatch($event)"
                        (keydown.escape)="$event.preventDefault(); closeStateDropdown()"
                        autocomplete="off" />
                      <svg class="dropdown-arrow" 
                           [class.rotated]="stateDropdownOpen" 
                           width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    
                    <div class="custom-dropdown-menu" *ngIf="stateDropdownOpen">
                      <div class="custom-dropdown-option"
                           *ngFor="let option of filteredStateOptions"
                           [class.selected]="option.value === formData.state"
                           [class.disabled]="isStateOptionDisabled(option)"
                           [title]="isStateOptionDisabled(option) ? 'This state is not available' : null"
                           (click)="selectState(option)">
                        {{ option.label }}
                      </div>
                      <div class="custom-dropdown-option custom-dropdown-empty" *ngIf="filteredStateOptions.length === 0">
                        No states found
                      </div>
                    </div>
                  </div>
                  <div class="form-error" *ngIf="formErrors.state">
                    {{ formErrors.state }}
                  </div>
                </div>
              </div>
            </div>
 
            <div class="form-row" *ngIf="shouldShowTreatmentSection()">
              <div class="form-col-full">
                <div class="treatment-type-container">
                  <h3 class="section-title form-subsection-title">
                    Type of treatment<span class="required-asterisk">*</span>
                  </h3>
                  
             
                  <div *ngIf="hasMultipleTreatmentOptions()" class="radio-group">
                    <div class="radio-option" *ngFor="let treatment of getAvailableTreatments()" [class.disabled]="isTreatmentTypeDisabled(treatment)" [title]="isTreatmentTypeDisabled(treatment) ? 'This visit type is not available' : null">
                      <input
                        type="radio"
                        [id]="'treatment-' + treatment"
                        [value]="treatment"
                        [attr.disabled]="isTreatmentTypeDisabled(treatment) ? '' : null"
                        [(ngModel)]="formData.treatmentType"
                        (ngModelChange)="onTreatmentTypeOptionClick($event)"
                        name="treatmentType"
                        class="radio-input">
                      <label [for]="'treatment-' + treatment" class="radio-label">
                        <span class="treatment-option-heading">{{ getTreatmentHeading(treatment) }}</span>
                        <span class="treatment-option-subtext">{{ getTreatmentDesc(treatment) }}</span>
                      </label>
                    </div>
                  </div>


                  <div *ngIf="hasSingleTreatmentOption()" class="single-treatment">
                    <div class="radio-option" [class.disabled]="isTreatmentTypeDisabled(getAvailableTreatments()[0])" [title]="isTreatmentTypeDisabled(getAvailableTreatments()[0]) ? 'This visit type is not available' : null">
                      <input
                        type="radio"
                        [id]="'treatment-' + getAvailableTreatments()[0]"
                        [value]="getAvailableTreatments()[0]"
                        [attr.disabled]="isTreatmentTypeDisabled(getAvailableTreatments()[0]) ? '' : null"
                        [(ngModel)]="formData.treatmentType"
                        (ngModelChange)="onTreatmentTypeOptionClick($event)"
                        name="treatmentType"
                        class="radio-input">
                      <label [for]="'treatment-' + getAvailableTreatments()[0]" class="radio-label">
                        <span class="treatment-option-heading">{{ getTreatmentHeading(getAvailableTreatments()[0]) }}</span>
                        <span class="treatment-option-subtext">{{ getTreatmentDesc(getAvailableTreatments()[0]) }}</span>
                      </label>
                    </div>
                    
                    
                    <div class="treatment-info">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="info-icon">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                      </svg>
                      <span>Please note that Medication Management is the only service available in your state.</span>
                    </div>
                  </div>
                  
                  <div class="form-error" *ngIf="formErrors.treatmentType">
                    {{ formErrors.treatmentType }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-col-full">
                <div class="coverage-container">
                  <h3 class="section-title form-subsection-title coverage-title">Coverage</h3>
                  <p class="coverage-subtitle">Choose a plan to view matching appointment options.</p>

                  <div class="custom-dropdown-container">
                    <label class="dropdown-label">
                      Insurance Carrier<span class="required-asterisk" *ngIf="payType !== 'self-pay'">*</span><span class="optional-text" *ngIf="payType === 'self-pay'">(Optional)</span>
                    </label>
                    <div class="custom-dropdown-wrapper" [class.open]="carrierDropdownOpen">
                      <div
                        id="carrierTrigger"
                        class="custom-dropdown-trigger carrier-search-trigger"
                        [class.has-value]="providerCarrier || carrierSearch"
                        [class.error]="formErrors.coverage && payType !== 'self-pay'"
                        (click)="openCarrierDropdown()">
                        <input
                          type="text"
                          class="dropdown-search-field"
                          placeholder="Start typing insurance name..."
                          [ngModel]="carrierDropdownOpen ? carrierSearch : providerCarrier"
                          [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="onCarrierSearchChange($event)"
                          (focus)="openCarrierDropdown()"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="selectFirstCarrierMatch($event)"
                          autocomplete="off" />
                        <svg class="dropdown-arrow" [class.rotated]="carrierDropdownOpen" width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>

                      <div class="custom-dropdown-menu" *ngIf="carrierDropdownOpen">
                        <div class="custom-dropdown-option" *ngFor="let carrier of filteredCarriers" [class.selected]="carrier.label === providerCarrier" (click)="selectCarrier(carrier)">
                          {{ carrier.label }}
                        </div>
                        <div class="custom-dropdown-option custom-dropdown-empty" *ngIf="filteredCarriers.length === 0">
                          {{ carrierDropdownEmptyMessage }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="treatment-info coverage-info">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="info-icon">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                    </svg>
                    <span>The insurance options shown are based on the details you entered and may vary depending on age and provider availability.</span>
                  </div>

                  <div class="coverage-checkbox-row">
                    <label class="coverage-checkbox">
                      <input type="checkbox" [checked]="payType === 'self-pay' && !noInsuranceCardWithMe" (change)="onSelfPayChange($any($event.target).checked)" />
                      <span>Self-pay/No insurance</span>
                    </label>
                  </div>
                  <p class="coverage-subtitle coverage-selfpay-note">We'll show available self-pay appointments.</p>
                  <div class="coverage-checkbox-row">
                    <label class="coverage-checkbox">
                      <input type="checkbox" [checked]="noInsuranceCardWithMe" (change)="onNoInsuranceCardChange($any($event.target).checked)" />
                      <span>I don't have my insurance card with me</span>
                    </label>
                  </div>

                  <div class="form-error" *ngIf="formErrors.coverage">
                    {{ formErrors.coverage }}
                  </div>
                </div>
              </div>
            </div>

            
         
            <div class="form-actions">
              <button type="button" class="previous-btn" (click)="onPrevious()">
                Previous
              </button>
              <button 
                type="submit" 
                class="submit-btn"
                (click)="trackSeeAvailableSlotsClick()"
                [disabled]="isCheckingExistingAccount || checkingAvailability || isSubmitting">
                See Available Slots
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

 
  <app-footer></app-footer>
</div>

 
<div class="toast-container" *ngIf="showInPersonSuccessToast">
  <div class="toast-success">
    <span class="toast-icon"></span>
    <span>Submitted successfully.</span>
    <div class="toast-progress"></div>    
  </div>
  
</div>
 
<div class="inperson-modal-backdrop" *ngIf="showInPersonModal">
  <div class="inperson-modal">
    <app-loader *ngIf="isSubmittingInPerson" [fullscreen]="true" [message]="'Saving'"></app-loader>
    <div class="modal-header">
      <span class="modal-title">In-Person Appointment</span>
      <button type="button" class="modal-close" (click)="closeInPersonModal()">✕</button>
    </div>
    <div class="modal-body">
      <div class="modal-grid">
        <div class="grid-col">
          <label class="modal-label">Legal First Name<span class="required-asterisk">*</span></label>
          <input type="text" class="modal-input" maxlength="20" [(ngModel)]="inPerson.firstName" (input)="modalErrors.firstName=''"/>
          <div class="modal-error" *ngIf="modalErrors.firstName">{{ modalErrors.firstName }}</div>
        </div>
        <div class="grid-col">
          <label class="modal-label">Legal Last Name<span class="required-asterisk">*</span></label>
          <input type="text" class="modal-input" maxlength="20" [(ngModel)]="inPerson.lastName" (input)="modalErrors.lastName=''"/>
          <div class="modal-error" *ngIf="modalErrors.lastName">{{ modalErrors.lastName }}</div>
        </div>
        <div class="grid-col">
          <label class="modal-label">Phone Number<span class="required-asterisk">*</span></label>
          <input type="text" class="modal-input" placeholder="" [(ngModel)]="inPerson.phone" (input)="formatInPersonPhone($event); modalErrors.phone=''" maxlength="12"/>
          <div class="modal-error" *ngIf="modalErrors.phone">{{ modalErrors.phone }}</div>
        </div>
        <div class="grid-col">
          <label class="modal-label">Email Address<span class="required-asterisk">*</span></label>
          <input type="email" class="modal-input" maxlength="40" [(ngModel)]="inPerson.email" (input)="modalErrors.email=''"/>
          <div class="modal-error" *ngIf="modalErrors.email">{{ modalErrors.email }}</div>
        </div>
        <div class="grid-col span-2 full-width">
          <label class="modal-label">What is your state of residence? <span class="required-asterisk">*</span></label>
          <div class="modal-select">
            <select class="modal-input" [(ngModel)]="inPerson.state" (change)="modalErrors.state=''">
              <option value="">Select your state</option>
              <option *ngFor="let st of modalStateOptions" [value]="st.value">{{ st.label }}</option>
            </select>
          </div>
          <div class="modal-error" *ngIf="modalErrors.state">{{ modalErrors.state }}</div>
        </div>
        <div class="grid-col span-2">
          <div class="info-note">
            <span class="info-icon">i</span>
            <div class="info-text">
              <strong>Note:</strong>Only telehealth services are available in your state. Our virtual appointments follow the same high standards of privacy, security, and compassionate care as our in-person visits
            </div>
          </div>
        </div>
      </div>
      <div class="consent-row">
        <input type="checkbox" class="consent-checkbox" [(ngModel)]="inPerson.consent" (change)="modalErrors.consent=''"/>
        <span class="consent-text">
          By checking this box, I consent to receive text messages related to information, appointments and practice updates from Animo Sano Psychiatry, PLLC. You can reply "STOP" at any time to opt-out. Message and data rates may apply. Message frequency may vary; text HELP to <a href="tel:+19193917202">(919) 391-7202</a> for assistance. For more information, please refer to our <a href="https://animosanopsychiatry.com/privacy-policy/" target="_blank">Privacy policy</a> and <a href="https://animosanopsychiatry.com/privacy-policy/#sms-tc" target="_blank">SMS Terms and Conditions</a> on our website.
        </span>
      </div>
      <div class="modal-error" *ngIf="modalErrors.consent">{{ modalErrors.consent }}</div>
    </div>
    <div class="modal-footer">
      <button type="button" class="modal-submit" (click)="submitInPerson()">Submit</button>
    </div>
  </div>
</div>

<div class="s65-backdrop" *ngIf="show65PlusModal">
  <div class="s65-modal">
    <div class="s65-header">
      <span class="s65-title">Screening Questions for Adults 65+</span>
      <button type="button" class="s65-close" (click)="close65PlusModal()">✕</button>
    </div>
    <div class="s65-body">
      <div class="s65-question">
        <div class="s65-question-title">1. Cognitive Diagnosis Screening</div>
        <div class="s65-question-text">Are you seeking care specifically for memory loss, dementia, or a neurocognitive condition?</div>
        <div class="s65-radio-row">
          <label class="s65-radio-label">
            <input type="radio" name="s65-cognitive" [value]="true" [(ngModel)]="screening65Plus.cognitiveDiagnosis">
            <span>Yes</span>
          </label>
          <label class="s65-radio-label">
            <input type="radio" name="s65-cognitive" [value]="false" [(ngModel)]="screening65Plus.cognitiveDiagnosis">
            <span>No</span>
          </label>
        </div>
        <p class="s65-message s65-message-error" *ngIf="screening65Plus.cognitiveDiagnosis === true">
          Our psychiatry services are not able to evaluate or treat memory loss, dementia, or neurocognitive conditions. We recommend speaking with your primary care provider for a referral to a specialist who can best support your needs.
        </p>
      </div>

      <div class="s65-question">
        <div class="s65-question-title">2. Medication Independence</div>
        <div class="s65-question-text">Is anyone else (nurse or other medical professional) responsible for administering your medications?</div>
        <div class="s65-radio-row">
          <label class="s65-radio-label">
            <input type="radio" name="s65-medication" [value]="true" [(ngModel)]="screening65Plus.medicationDependence">
            <span>Yes</span>
          </label>
          <label class="s65-radio-label">
            <input type="radio" name="s65-medication" [value]="false" [(ngModel)]="screening65Plus.medicationDependence">
            <span>No</span>
          </label>
        </div>
        <p class="s65-message s65-message-error" *ngIf="screening65Plus.medicationDependence === true">
          Our telehealth model requires patients to independently manage their medications; we may not be the right fit for your current situation. We encourage you to speak with your existing care team to help find the right support.
        </p>
      </div>

      <div class="s65-question">
        <div class="s65-question-title">3. Clinical Decision-Making Authority</div>
        <div class="s65-question-text">Is there a Power of Attorney (POA) or a Healthcare Proxy who makes medical decisions on your behalf?</div>
        <div class="s65-radio-row">
          <label class="s65-radio-label">
            <input type="radio" name="s65-poa" [value]="true" [(ngModel)]="screening65Plus.poaProxy">
            <span>Yes</span>
          </label>
          <label class="s65-radio-label">
            <input type="radio" name="s65-poa" [value]="false" [(ngModel)]="screening65Plus.poaProxy">
            <span>No</span>
          </label>
        </div>
        <p class="s65-message s65-message-error" *ngIf="screening65Plus.poaProxy === true">
          Our practice requires that patients be able to make their own medical decisions independently. Because a Power of Attorney or Healthcare Proxy is in place for your care, we are unable to proceed with scheduling at this time.
        </p>
      </div>

      <div class="s65-question">
        <div class="s65-question-title">4. Technology Independence</div>
        <div class="s65-question-text">Do you require assistance using a smartphone, tablet, or computer to complete intake forms and attend video appointments?</div>
        <div class="s65-radio-row">
          <label class="s65-radio-label">
            <input type="radio" name="s65-tech" [value]="true" [(ngModel)]="screening65Plus.technologyAssist">
            <span>Yes</span>
          </label>
          <label class="s65-radio-label">
            <input type="radio" name="s65-tech" [value]="false" [(ngModel)]="screening65Plus.technologyAssist">
            <span>No</span>
          </label>
        </div>
        <p class="s65-message s65-message-error" *ngIf="screening65Plus.technologyAssist === true">
          We are happy to provide technical support. Please call our office before your appointment if you have any question at 919-391-7202.
        </p>
      </div>
    </div>
    <div class="s65-footer">
      <button type="button" class="s65-cancel-btn" (click)="close65PlusModal()">Cancel</button>
      <button type="button" class="s65-submit-btn" [disabled]="!screening65PlusCanProceed" (click)="trackOlderAdultsSeeAvailableSlotsClick(); on65PlusProceed()">See Available Slots</button>
    </div>
  </div>
</div>

<div class="s65-backdrop" *ngIf="show65PlusUncertainModal">
  <div class="s65-modal s65-modal-small">
    <div class="s65-header">
      <span class="s65-title">Screening Questions for Adults 65+</span>
      <button type="button" class="s65-close" (click)="on65PlusUncertainClose()">✕</button>
    </div>
    <div class="s65-body s65-body-small">
      <p class="s65-center-message">
        We are uncertain at this time if a virtual psychiatry appointment would be the best fit for you. Please call our team to discuss your situation and needs further.
        <a href="tel:9193977202" class="s65-phone-number">919-397-7202</a>
      </p>
    </div>
    <div class="s65-footer s65-footer-right">
      <button type="button" class="s65-cancel-btn" (click)="on65PlusUncertainClose()">Close</button>
    </div>
  </div>
</div>

<app-appointment-support-needed
  [isVisible]="showSupportNeededModal"
  (close)="closeSupportNeededModal()">
</app-appointment-support-needed>
